import React, { Component, Fragment } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import Modal from '../../../../UniformComponents/Modal'
import CheckboxGroup from '../../../form/CheckboxGroup'

@observer
class ComparisonModal extends Component {
    changeYears = (obj) => {
        const { reportStore } = this.props
        const { yoyComparisons, lastYearSurveys, reloadComparison } = reportStore
        yoyComparisons.clear()
        obj.value.forEach((v) => {
            yoyComparisons.set(
                v,
                lastYearSurveys.find(({ value }) => value === v),
            )
        })
        reloadComparison()
    }

    changePeriods = ({ name }) => {
        const { reportStore } = this.props
        const { changeBenchmarkPeriod, benchmarkPeriods } = reportStore
        changeBenchmarkPeriod({ period: benchmarkPeriods.find((p) => p.value === name).period })
    }

    changeBenchmarks = (obj) => {
        const { reportStore } = this.props
        const { benchmarks2, benchmarkOptions } = reportStore
        benchmarks2.clear()
        obj.value.forEach((b) => {
            benchmarks2.set(
                b,
                benchmarkOptions.find((benchmark) => benchmark.value === b),
            )
        })
    }

    render() {
        const { reportStore, showComparisonSelector, toggleComparisonSelector } = this.props
        const { appStore } = reportStore
        const { survey } = appStore
        const showBenchmarks = R.pathOr(undefined, ['metadata', 'taxonomy', 'surveyType'], survey) === 'PE'
        const { benchmarkOptions } = reportStore
        const periodOptions = reportStore.benchmarkPeriods
        const yearOptions = reportStore.lastYearSurveys.filter((y) => !!y.label)

        if ((!benchmarkOptions.length || !showBenchmarks) && !yearOptions.length) {
            return (
                <Modal show={showComparisonSelector} onClose={toggleComparisonSelector} cssClass="comparisonModal">
                    <div className="comparisonSelector reportingComparisonModal">
                        <h3>{i18n.t('reports.noComparisons')}</h3>
                    </div>
                </Modal>
            )
        }

        return (
            <Modal show={showComparisonSelector} onClose={toggleComparisonSelector} cssClass="comparisonModal">
                <div className="comparisonSelector reportingComparisonModal">
                    {showBenchmarks && benchmarkOptions.length ? (
                        <Fragment>
                            <div className="benchmarks">
                                <CheckboxGroup
                                    name="benchmarks"
                                    label={i18n.t('report_benchmark_filter_label')}
                                    options={benchmarkOptions}
                                    defaultChecked={Array.from(reportStore.benchmarks2)
                                        .filter(([_, value]) => !!value)
                                        .map(([key]) => key)}
                                    onBlur={this.changeBenchmarks}
                                    returnValueUnchanged
                                />
                            </div>
                            <div className="periods">
                                <CheckboxGroup
                                    name="periods"
                                    label={i18n.t('report_benchmark_period_label')}
                                    options={periodOptions}
                                    radioValue={reportStore.benchmarkPeriod.duration}
                                    defaultChecked={[]}
                                    onBlur={this.changePeriods}
                                    radio
                                    returnValueUnchanged
                                />
                            </div>
                        </Fragment>
                    ) : null }
                    {yearOptions.length ? (
                        <div className="years">
                            <CheckboxGroup
                                name="years"
                                label={i18n.t('report_year_filter_label')}
                                options={yearOptions}
                                defaultChecked={Array.from(reportStore.yoyComparisons).map(([key]) => key)}
                                onBlur={this.changeYears}
                                returnValueUnchanged
                            />
                        </div>
                    ) : null }
                </div>
            </Modal>
        )
    }
}

export default ComparisonModal
